import authService from './authService'
import autConfig from './authConfig'

export default {
  config: autConfig,
  service:(function (axiosIns) {
    return new authService(axiosIns)
  })()
}

